import { dashboard } from 'js/src/data/dashboard/dashboard-reducers';

/* MODULE EXPORTS */
export * from 'js/src/data/dashboard/dashboard-operations';
export * from 'js/src/data/dashboard/dashboard-selectors';
export * from 'js/src/data/dashboard/dashboard-types';
export * from 'js/src/data/dashboard/dashboard-actions';
export * from 'js/src/data/dashboard/dashboard-utils';
export * from 'js/src/data/dashboard/dashboard-routes';

export default dashboard;
